// pages/ResetPassword.jsx
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [password1, setPassword1] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== password1) {
      toast.error("รหัสผ่านไม่ตรงกัน");
      return;
    }
    if (password.length < 6) {
      toast.error("รหัสผ่านต้องมีอย่างน้อย 6 ตัว");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API}/reset-password`, {
        token,
        password,
      });
      toast.success("รีเซ็ตรหัสผ่านสำเร็จ");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data || "ลิงก์หมดอายุหรือไม่ถูกต้อง");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: "2.5rem 2rem",
          width: "90%",
          maxWidth: 400,
          boxShadow: "0 3px 20px rgba(0,0,0,0.12)",
        }}
      >
        <h4 style={{ fontWeight: 500, marginBottom: 6 }}>ตั้งรหัสผ่านใหม่</h4>
        <p style={{ color: "#888", fontSize: 13, marginBottom: 20 }}>
          กรอกรหัสผ่านใหม่ของคุณ
        </p>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: 12 }}
        >
          <div>
            <label
              style={{
                fontSize: 13,
                color: "#666",
                display: "block",
                marginBottom: 4,
              }}
            >
              รหัสผ่านใหม่
            </label>
            <input
              className="form-control"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label
              style={{
                fontSize: 13,
                color: "#666",
                display: "block",
                marginBottom: 4,
              }}
            >
              ยืนยันรหัสผ่านใหม่
            </label>
            <input
              className="form-control"
              type="password"
              value={password1}
              onChange={(e) => setPassword1(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="btn"
            style={{ background: "#FF70A6", color: "#fff" }}
            disabled={loading || password.length < 6}
          >
            {loading ? "กำลังบันทึก..." : "ยืนยันรีเซ็ตรหัสผ่าน"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
